/** Extend JS's base error class. */
export default class StargateError extends Error {
    constructor(message) {
        super(message);
        this.name = 'StargateError';
    }
}
